import { AxiosRequestConfig, Method } from 'axios';
import { apiRequest } from './apiClient';

abstract class BaseApiService {
    private readonly basePath: string;
    protected constructor(basePath: string) {
        this.basePath = basePath.replace(/^\/+/, '');
    }
    protected GET<T>(path = '', options?: AxiosRequestConfig): Promise<T> {
        return this.safeFetch<T>(this.resolvePath(path), 'get', undefined, options);
    }
    protected GETBYID<T>(id: string, options?: AxiosRequestConfig): Promise<T> {
        return this.safeFetch<T>(this.resolvePath(id), 'get', undefined, options);
    }
    protected POST<T, TData = unknown>(path = '', data?: TData, options?: AxiosRequestConfig): Promise<T> {
        return this.safeFetch<T>(this.resolvePath(path), 'post', data, options);
    }
    protected PUT<T, TData = unknown>(path = '', data?: TData, options?: AxiosRequestConfig): Promise<T> {
        return this.safeFetch<T>(this.resolvePath(path), 'put', data, options);
    }
    protected DELETE<T, TData = unknown>(path = '', data?: TData, options?: AxiosRequestConfig): Promise<T> {
        return this.safeFetch<T>(this.resolvePath(path), 'delete', data, options);
    }
    private resolvePath(path = '') {
        const cleanPath = path.replace(/^\/+/, '');
        if (!cleanPath)
            return this.basePath;
        if (!this.basePath)
            return cleanPath;
        return `${this.basePath}/${cleanPath}`;
    }
    private safeFetch<T>(path: string, method: Method, data?: unknown, options: AxiosRequestConfig = {}): Promise<T> {
        return apiRequest<T>(path, method, data, options);
    }
}
export default BaseApiService;
